<template>
  <content>
    <MapButtons></MapButtons>

    <CircuitsSideBar :circuits="circuits" :isLoading="isLoading">
    </CircuitsSideBar>

    <MglMap
      class="mt-n1 ml-0 mb-n12"
      style="height: 94vh; width: 100vw"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :pitch="pitch"
      :center="center"
      :zoom="zoom"
      :bearing="rotation"
      @load="onMapLoaded"
    >
      <MglNavigationControl position="bottom-right" />
      <MglGeolocateControl position="bottom-right" />

      <MglMarker
        v-for="(circuit, i) in mapCircuits"
        :key="i"
        :coordinates="[circuit.longitude, circuit.latitude]"
        color="blue"
      >
        <div slot="marker">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :style="{
                  'background-color': circuit.online == 3 ? 'green' : 'red',
                }"
                outlined
                fab
                dark
                x-small
                color="blue-grey lighten-1"
                elevation="4"
              >
                <v-icon v-on="on" color="white">mdi-router-wireless</v-icon>
              </v-btn>
            </template>
            <span>{{ circuit.designacaoCliente }}</span>
          </v-tooltip>
        </div>
        <MglPopup
          :offset="16"
          :closeButton="false"
          :showed="showPopups[i] && showPopups[i].show"
        >
          <CircuitPopupCard :circuit="Object.assign({}, circuit)">
          </CircuitPopupCard>
        </MglPopup>
      </MglMarker>

      <MglMarker
        v-for="marker in starts"
        :key="marker.id"
        :coordinates="[marker.longitude, marker.latitude]"
        color="blue"
      >
        <div slot="marker">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :style="{
                  'background-color': 'blue',
                }"
                outlined
                fab
                dark
                x-small
                color="blue-grey lighten-1"
                elevation="4"
              >
                <v-icon v-on="on" color="white">mdi-clock-out</v-icon>
              </v-btn>
            </template>
            <span
              v-html="
                '<p style=\'margin-top:5px; text-align: center;\'>' +
                $vuetify.lang.t('$vuetify.INICIO_ROTA') +
                '</p><p style=\'margin-top:-10px; text-align: center; margin-bottom:0px;\'>' +
                marker.nome +
                '</p>'
              "
            ></span>
          </v-tooltip>
        </div>
      </MglMarker>

      <MglMarker
        v-for="marker in ends"
        :key="marker.id"
        :coordinates="[marker.longitude, marker.latitude]"
        color="blue"
      >
        <div slot="marker">
          <v-menu transition="slide-x-transition" bottom right>
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :style="{
                      'background-color': 'grey',
                    }"
                    outlined
                    fab
                    dark
                    x-small
                    color="blue-grey lighten-1"
                    elevation="4"
                    v-bind="attrs"
                    v-on="{ ...menu }"
                  >
                    <v-icon v-on="on" color="white">mdi-clock-in</v-icon>
                  </v-btn>
                </template>
                <span
                  v-html="
                    '<p style=\'margin-top:5px; text-align: center;;\'>' +
                    $vuetify.lang.t('$vuetify.FIM_ROTA') +
                    '</p><p style=\'margin-top:-10px; text-align: center; margin-bottom:0px;\'>' +
                    marker.nome +
                    '</p>'
                  "
                ></span>
              </v-tooltip>
            </template>
             <v-list>
                  <v-list-item
                    @click="removeRoute({ circuit: { nome: marker.id } })"
                  >
                    <v-list-item-title>{{
                      $vuetify.lang.t("$vuetify.ESCONDER_ROTA")
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>

          </v-menu>
        </div>
      </MglMarker>
    </MglMap>
  </content>
</template>

<script>
import MapButtons from "../components/MapButtons";
import Mapboxgl from "mapbox-gl";
import promisify from "map-promisified";
import CircuitsSideBar from "../components/CircuitsSideBar";
import CircuitPopupCard from "../components/cards/CircuitPopupCard";
import * as turf from "@turf/turf";

import {
  MglMap,
  MglNavigationControl,
  MglGeolocateControl,
  MglMarker,
  MglPopup,
} from "vue-mapbox";

export default {
  components: {
    MapButtons,
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    MglPopup,
    CircuitsSideBar,
    CircuitPopupCard,
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoidGVsZXNwYXppb2JyIiwiYSI6ImNtMTByNWl2YTBoenYybW9kcXYwa2VhN3YifQ.KYJNtxCsKkTZkarLcZtCxg",
      mapStyle: "mapbox://styles/mapbox/streets-v11?optimize=true",
      pitch: 60,
      center: [-43.244715266733785, -22.426041018417468],
      zoom: 11,
      rotation: 0,
      circuits: [],
      mapCircuits: [],
      actions: undefined,
      showPopups: [],
      searchText: undefined,
      contractNumber: undefined,
      isLoading: false,
      lastAppState: undefined,
      intervalId: undefined,
      routes: [],
      starts: [],
      ends: [],
      status: undefined,
    };
  },
  methods: {
    showStoragedCircuitInMap() {
      var circuit = JSON.parse(window.sessionStorage.getItem("circuit"));
      this.loadDistinctDevicesToMap(circuit);

      this.circuits.push(circuit);
      this.flyTo(circuit);
      this.showPopup(circuit);
      this.loadDistinctDeviceToList(circuit);
      window.sessionStorage.setItem("circuit", null);
      this.isLoading = false;
    },
    changeAngle() {
      this.pitch = this.pitch == 60 ? 0 : 60;
    },
    clearMap() {
      this.mapCircuits = [];
      this.starts = [];
      this.ends = [];

      for (var index in this.routes) {
        this.mapbox.removeLayer(this.routes[index].circuit.nome + "1");
        this.mapbox.removeLayer(this.routes[index].circuit.nome);
        this.mapbox.removeSource(this.routes[index].circuit.nome);
      }

      this.routes = [];
    },
    showPopup(circuit) {
      this.loadDistinctDevicesToMap(circuit, true);

      for (var i in this.showPopups) {
        this.showPopups[i].show = false;
      }

      for (var index in this.showPopups) {
        if (this.showPopups[index].nome == circuit.nome) {
          this.showPopups[index].show = true;
        }
      }
    },
    async flyTo(circuit, speed) {
      if (!this.actions) return;
      await this.actions.flyTo({
        center: [circuit.longitude, circuit.latitude],
        speed: speed || 0.8,
        curve: 1,
      });
    },
    onMapLoaded(event) {
      this.mapbox = event.map;
      this.actions = promisify(event.map);

      event.map.on("zoomend", (e) => {
        this.$appState().mapZoom = e.target.getZoom();
      });

      event.map.on("pitchend", (e) => {
        this.$appState().mapPitch = e.target.getPitch();
      });

      event.map.on("dragend", (e) => {
        this.$appState().mapPosition = e.target.getCenter();
      });

      event.map.on("moveend", (e) => {
        this.$appState().mapPosition = e.target.getCenter();
        this.updateEligiblesToMap();
      });

      event.map.on("rotateend", (e) => {
        this.$appState().mapRotation = e.target.getBearing();
      });

      event.map.on("mouseup", () => {
        this.hideAllPopups();
      });

      event.map.on("style.load", () => {
        this.updateLayers();
      });

      if (window.sessionStorage.getItem("circuit")) {
        this.showStoragedCircuitInMap();
      }

      this.addBuildings(event.map);
    },
    updateEligiblesToMap() {

      this.mapCircuits = [];
      var popups = [];
      var bounds = this.mapbox.getBounds();

      for (var index in this.circuits) {
        var popup = this.isPopupVisible(this.circuits[index]);
        if (this.eligibleToMap(this.circuits[index], bounds) || (popup && popup.show)) {
          this.mapCircuits.push(Object.assign({}, this.circuits[index]));
          popups.push(
            popup || { nome: this.circuits[index].nome, show: false }
          );
        }
      }

      this.showPopups = popups;
    },
    isPopupVisible(circuit) {
      for (var index in this.showPopups) {
        if (
          this.showPopups[index].nome == circuit.nome &&
          this.showPopups[index].show
        ) {
          return this.showPopups[index];
        }
      }

      return undefined;
    },
    addBuildings(map) {
      var layers = map.getStyle().layers;
      var labelLayerId = layers.find(
        (layer) => layer.type === "symbol" && layer.layout["text-field"]
      ).id;

      map.addLayer(
        {
          id: "add-3d-buildings",
          source: "composite",
          "source-layer": "building",
          filter: ["==", "extrude", "true"],
          type: "fill-extrusion",
          minzoom: 15,
          paint: {
            "fill-extrusion-color": "#aaa",

            // Use an 'interpolate' expression to
            // add a smooth transition effect to
            // the buildings as the user zooms in.
            "fill-extrusion-height": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "height"],
            ],
            "fill-extrusion-base": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "min_height"],
            ],
            "fill-extrusion-opacity": 0.6,
          },
        },
        labelLayerId
      );
    },
    search() {
      this.isLoading = true;
      this.$get("/circuito/localizacao", {
        searchText: this.searchText || "",
        status: this.status = undefined? undefined : this.status,
        contractNumber: JSON.parse(window.sessionStorage.getItem("contract"))
          .numeroContratoTpz,
      }).then((response) => {
        if (!response) {
          return;
        }

        this.circuits = response.data;
        this.isLoading = false;
        this.loadDistinctDevicesToMap();
      });
    },
    loadDistinctDevicesToMap(circuit, insertAnyWay) {

      var hasItem = false;
      var bounds = this.mapbox.getBounds();
      
      if (circuit) {
        for (var i in this.mapCircuits) {
          if (circuit.nome == this.mapCircuits[i].nome) {
            hasItem = true;
            break;
          }
        }

        if (!hasItem && (this.eligibleToMap(circuit, bounds) || insertAnyWay)) {
          this.mapCircuits.push(Object.assign({}, circuit));
        }

        this.hideAllPopups();
        return;
      }

      this.mapCircuits = [];
      for (var index in this.circuits) {
        if (
          (this.eligibleToMap(this.circuits[index], bounds) || insertAnyWay)) {
          this.mapCircuits.push(Object.assign({}, this.circuits[index]));
        }
      }
    },
    hideAllPopups(){
      this.showPopups = this.mapCircuits.map((m) => {
        return { nome: m.nome, show: false };
      });
    },
    eligibleToMap(circuit, bounds) {
      if (!circuit.longitude || !circuit.latitude) {
        return false;
      }

      if (
        this.inBounds({ lng: circuit.longitude, lat: circuit.latitude }, bounds) &&
        (this.mapCircuits.length < 200 || circuit.isFocused)
      ) {
        return true;
      }

      return false;
    },
    inBounds(point, bounds) {
      var lng = (point.lng - bounds._ne.lng) * (point.lng - bounds._sw.lng) < 0;
      var lat = (point.lat - bounds._ne.lat) * (point.lat - bounds._sw.lat) < 0;
      return lng && lat;
    },
    loadMapPreferences() {
      this.$getUser().then((user) => {
        if (user.preferencias) {
          this.$appState().mapZoom = user.preferencias.zoomMapa || 11;
          this.$appState().mapRotation = user.preferencias.rotacaoMapa || 0;
          this.$appState().mapPitch = user.preferencias.anguloMapa;
          this.$appState().mapPosition = {
            lat: user.preferencias.latitudeMapa,
            lng: user.preferencias.longitudeMapa,
          };
          this.$appState().lastSearch = user.preferencias.ultimaBusca || "";
          this.$appState().mapStyle =
            user.preferencias.estiloMapa || "streets-v11";

          this.$root.$emit("change-mode", this.$appState().mapStyle);
          this.searchText = this.$appState().lastSearch;
          this.search();

          this.center = [
            user.preferencias.longitudeMapa,
            user.preferencias.latitudeMapa,
          ] || [-43.244715266733785, -22.426041018417468];
          this.zoom = this.$appState().mapZoom;
          this.rotation = this.$appState().mapRotation;
          this.pitch = this.$appState().mapPitch;
          this.rotation = this.$appState().mapRotation;
          this.$forceUpdate();
        } else {
          this.searchText = this.$appState().lastSearch || "";
          //this.search();
        }
      });
    },
    hasChangedState() {
      return (
        this.$appState().mapRotation != this.lastAppState.mapRotation ||
        this.$appState().mapZoom != this.lastAppState.mapZoom ||
        this.$appState().mapPitch != this.lastAppState.mapPitch ||
        this.$appState().lastSearch != this.lastAppState.lastSearch ||
        this.$appState().mapPosition != this.lastAppState.mapPosition ||
        this.$appState().mapStyle != this.lastAppState.mapStyle
      );
    },
    loadDistinctDeviceToList(device) {
      var hasItem = false;
      for (var index in this.circuits) {
        if (this.circuits[index].nome == device.nome) {
          hasItem = true;
          break;
        }
      }

      if (!hasItem) {
        this.circuits.push(device);
      }
    },
    diffBetween(number1, number2) {
      return number1 > number2 ? number1 - number2 : number2 - number1;
    },
    updateLayers() {
      for (var index in this.routes) {
        var coordinates = this.routes[index].coordinates;
        coordinates.push([
          this.routes[index].circuit.longitude,
          this.routes[index].circuit.latitude,
        ]);
        this.addRouteLayers(this.routes[index], coordinates);
      }
    },
    addRouteLayers(route, coordinates) {
      this.mapbox.addSource(route.circuit.nome, {
        type: "geojson",
        buffer: 0,
        data: {
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: coordinates,
          },
        },
      });

      this.mapbox.addLayer({
        id: route.circuit.nome,
        type: "line",
        source: route.circuit.nome,
        layout: {
          "line-join": "round",
          "line-cap": "butt",
        },
        paint: {
          "line-color": "#FF3D00",
          "line-width": 6,
        },
      });

      this.mapbox.addLayer({
        id: route.circuit.nome + "1",
        type: "line",
        source: route.circuit.nome,
        layout: {
          "line-join": "round",
          "line-cap": "butt",
        },
        paint: {
          "line-color": "#78909C",
          "line-width": 6,
          "line-opacity": 0.4,
        },
      });
    },
    fitRouteBounds(route, coordinates) {
      // Create a 'LngLatBounds' with both corners at the first coordinate.
      const bounds = new Mapboxgl.LngLatBounds(coordinates[0], coordinates[0]);

      // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
      for (const coord of coordinates) {
        bounds.extend(coord);
      }

      this.mapbox.fitBounds(bounds, {
        padding: 100,
      });

      this.animateRoute(route);

      if (this.startDiffersFromEnd(coordinates)) {
        this.starts.push({
          id: route.circuit.nome,
          nome: route.circuit.designacaoCliente,
          latitude: coordinates[0][1],
          longitude: coordinates[0][0],
        });

        this.ends.push({
          id: route.circuit.nome,
          nome: route.circuit.designacaoCliente,
          latitude: coordinates[coordinates.length - 1][1],
          longitude: coordinates[coordinates.length - 1][0],
        });
      }
    },
    startDiffersFromEnd(coordinates) {
      if (coordinates[0][0] == null || coordinates[0][1] == null) {
        return true;
      }

      if (
        coordinates[0][0].toFixed(3) ==
          coordinates[coordinates.length - 1][0].toFixed(3) &&
        coordinates[0][1].toFixed(3) ==
          coordinates[coordinates.length - 1][1].toFixed(3)
      ) {
        return false;
      }

      return true;
    },
    animateRoute(route) {
      const dashArraySequence = [
        [0, 4, 3],
        [0.5, 4, 2.5],
        [1, 4, 2],
        [1.5, 4, 1.5],
        [2, 4, 1],
        [2.5, 4, 0.5],
        [3, 4, 0],
        [0, 0.5, 3, 3.5],
        [0, 1, 3, 3],
        [0, 1.5, 3, 2.5],
        [0, 2, 3, 2],
        [0, 2.5, 3, 1.5],
        [0, 3, 3, 1],
        [0, 3.5, 3, 0.5],
      ];

      let step = 0;

      var vm = this;
      function animateDashArray(timestamp) {
        // Update line-dasharray using the next value in dashArraySequence. The
        // divisor in the expression `timestamp / 50` controls the animation speed.
        const newStep = parseInt((timestamp / 50) % dashArraySequence.length);

        if (
          newStep !== step &&
          vm.routes.filter((el) => el.circuit.nome == route.circuit.nome)
            .length != 0
        ) {
          vm.mapbox.setPaintProperty(
            route.circuit.nome,
            "line-dasharray",
            dashArraySequence[step]
          );
          step = newStep;
        }

        // Request the next frame of the animation.
        requestAnimationFrame(animateDashArray);
      }

      // start the animation
      animateDashArray(0);
    },
    moveDeviceToNewLocation(mapDevice, circuit) {
      const origin = [mapDevice.longitude, mapDevice.latitude];
      const destination = [circuit.longitude, circuit.latitude];

      // A simple line from origin to destination.
      const route = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [origin, destination],
            },
          },
        ],
      };

      // Calculate the distance in kilometers between route start/end point.
      const lineDistance = turf.length(route.features[0]);
      const steps = 500;
      const arc = [];

      // Draw an arc between the `origin` & `destination` of the two points
      for (let i = 0; i < lineDistance; i += lineDistance / steps) {
        const segment = turf.along(route.features[0], i);
        arc.push(segment.geometry.coordinates);
      }

      // Update the route with calculated arc coordinates
      route.features[0].geometry.coordinates = arc;

      function animateMoviment() {
        const start =
          route.features[0].geometry.coordinates[
            counter >= steps ? counter - 1 : counter
          ];

        const end =
          route.features[0].geometry.coordinates[
            counter >= steps ? counter : counter + 1
          ];

        if (!start || !end) {
          return;
        }

        // Update point geometry to a new position based on counter denoting
        // the index to access the arc
        mapDevice.latitude = route.features[0].geometry.coordinates[counter][1];
        mapDevice.longitude =
          route.features[0].geometry.coordinates[counter][0];

        if (counter < steps) {
          requestAnimationFrame(animateMoviment);
        }

        counter = counter + 1;
      }

      // Used to increment the value of the point measurement against the route.
      let counter = 0;
      animateMoviment(counter, mapDevice, steps, route);
    },
    removeRoute(route){
      this.starts = this.starts.filter((el) => el.id !== route.circuit.nome);
      this.ends = this.ends.filter((el) => el.id !== route.circuit.nome);

      this.mapbox.removeLayer(route.circuit.nome + "1");
      this.mapbox.removeLayer(route.circuit.nome);
      this.mapbox.removeSource(route.circuit.nome);

      this.routes = this.routes.filter(
        (el) => el.circuit.nome !== route.circuit.nome
      );
    }
  },
  created() {
    this.$root.$on("localizacao", (circuit) => {
      for (var index in this.circuits) {
        if (this.circuits[index].nome == circuit.designacaoTpz) {
          this.circuits[index].latitude = circuit.latitude;
          this.circuits[index].longitude = circuit.longitude;
          this.circuits[index].velocidade = circuit.velocidade;
          break;
        }
      }

      for (var index2 in this.mapCircuits) {
        if (this.mapCircuits[index2].nome == circuit.designacaoTpz) {
          this.mapCircuits[index2].velocidade = circuit.velocidade;
          this.moveDeviceToNewLocation(this.mapCircuits[index2], circuit);
          break;
        }
      }

      this.$forceUpdate();
    });

    this.$root.$on("status", (circuit) => {
      for (var index in this.circuits) {
        if (this.circuits[index].nome == circuit.designacaoTpz) {
          this.circuits[index].online = circuit.status;
        }
      }

      for (var index2 in this.mapCircuits) {
        if (this.mapCircuits[index2].nome == circuit.designacaoTpz) {
          this.mapCircuits[index2].online = circuit.status;
        }
      }

      this.$forceUpdate();
    });

    this.$root.$on("change-mode", (mode) => {
      this.mapStyle = !mode.includes("mapbox")
        ? "mapbox://styles/mapbox/" + mode
        : mode;

      setTimeout(() => this.addBuildings(this.mapbox), 1000);

      this.$appState().mapStyle = mode;
    });

    this.isLoading = true;

    this.$root.$on("search", (searchText, status) => {
      this.searchText = searchText;
      this.status = status;
      this.search();
      this.$appState().lastSearch = searchText;
    });

    this.$root.$on("clear-map", () => {
      this.clearMap();
    });

    this.$root.$on("change-angle", () => {
      this.changeAngle();
    });

    this.$root.$on("show-popup", (device) => {
      this.showPopup(device);
    });

    this.$root.$on("fly-to", (device) => {
      this.flyTo(device);
    });

    this.$root.$on("online", (receivedMessage) => {
      for (var index in this.mapCircuits) {
        if (this.mapCircuits[index].nome == receivedMessage.nome) {
          this.mapCircuits[index].online = true;

          this.mapCircuits[index].ultimaAmostra = { date: {}, time: {} };

          var now = new Date();
          this.mapCircuits[index].ultimaAmostra.date.year = now.getFullYear();
          this.mapCircuits[index].ultimaAmostra.date.month = now.getMonth();
          this.mapCircuits[index].ultimaAmostra.date.day = now.getDate();
          this.mapCircuits[index].ultimaAmostra.time.hour = now.getHours();
          this.mapCircuits[index].ultimaAmostra.time.minute = now.getMinutes();
          this.mapCircuits[index].ultimaAmostra.time.second = now.getSeconds();

          this.$forceUpdate();
        }
      }
    });

    this.$root.$on("offline", (receivedMessage) => {
      for (var index in this.mapCircuits) {
        if (this.mapCircuits[index].nome == receivedMessage.nome) {
          this.mapCircuits[index].online = false;
        }
      }
    });

    this.$root.$on("remove-route", (route) => {
        this.removeRoute(route);
    });

    this.$root.$on("show-route", (route) => {
      this.routes.push(route);

      var coordinates = route.coordinates;

      this.addRouteLayers(route, coordinates);
      this.fitRouteBounds(route, coordinates);
    });

    this.intervalId = setInterval(() => {
      if (!this.lastAppState || this.hasChangedState()) {
        //this.$saveAppState();
        this.lastAppState = Object.assign({}, this.$appState());
      }
    }, 60000);

    window.sessionStorage.setItem("intervalId", this.intervalId);
  },
  beforeMount() {
    window.addEventListener("beforeunload", async () => {
      clearInterval(this.intervalId);
      //await this.$saveAppState();
    });
  },
};
</script>
<style>
.v-btn.v-btn--outlined {
  border-width: 2px;
  border-color: white;
}
.v-navigation-drawer {
  background-color: transparent;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}
.list-enter-active,
.list-leave-active {
  transition: opacity 0.5s ease;
}
.list-move {
  transition: transform 0.5s ease-out;
}
.mapboxgl-popup-content {
  padding: 0px 0px 12px;
  margin-left: -0.6rem;
  background: #fff0 !important;
}
.mapboxgl-ctrl {
  z-index: 2;
}
</style>